<template>
    <StoryTab
        v-if="tab == 'story' || tab == 'story_share'"
        :tab="tab"
        :mode="mode"
        :files="files"
        :dataFormRequest="dataFormRequest"
        :saveAllFormData="saveAllFormData"
        :formData="formData"
        :previewMode="previewMode"
        @addFile="uploadFile"
        @changeTab="changeTab"
        @generateFormData="generateFormData"
        @generateDataFormRequest="generateDataFormRequest"
        @saveDraft="saveDraft"
        @restoreFormData="restoreFormData"
        @saveFormData="saveFormData"
        @changePreviewDisplay="changePreviewDisplay"
        @sendPostAllPost="sendPostAllPost"
     
    />
    <StandardTab 
        v-else
        :mode="mode"
        :files="files"
        :dataFormRequest="dataFormRequest"
        :saveAllFormData="saveAllFormData"
        :formData="formData"
        :previewMode="previewMode"
        @addFile="uploadFile"
        @changeTab="changeTab"
        @generateFormData="generateFormData"
        @generateDataFormRequest="generateDataFormRequest"
        @saveDraft="saveDraft"
        @restoreFormData="restoreFormData"
        @saveFormData="saveFormData"
        @changePreviewDisplay="changePreviewDisplay"
        @sendPostAllPost="sendPostAllPost"

    />
</template>

<script>
import { EventBus } from '@/event-bus';

import store from './../../../store/index.js';
import StandardTab from '../postCreator/StandardTab.vue';
import StoryTab from '../postCreator/StoryTab.vue';

import { getInfoFile, getErrorNetworkFile, postNetworkValidator } from './../postCreator/utils.js'
import SSE from './../../../utils/sse.js'

import postMixin from './../../mixins/Posts.vue'
import draftMixin from './../../mixins/Drafts.vue'
import { formDataDefault, maxFilesPerNetwork, listNetworkSort } from './../postCreator/constante.js'

import { 
    findDifferences,
    mergeUpdates, 
    unescapeSpecialChars, 
    deepClone, 
    getVideoDuration,
    getFilesByNetwork
} from './../postCreator/utils.js'

import { draftTemplate } from './../postCreator/constante'

export default {

    mixins: [postMixin, draftMixin],

    components: {
        StandardTab,
        StoryTab
    },

    props: {
        mode: String,
        tab: {
            type : String,
            default : 'standard'
        },
    },

    data() {
        return {
            saveAllFormData:{
                main: {},
                networks: {},
                pages: {},
            },
            formData: JSON.parse(JSON.stringify(formDataDefault)),
            files:{},
            dataFormRequest : {},
            previewMode: {
                active : false,
                pageSelected: null
            },
            dataEditPost: {},
            draft: {},
        }
    },
    

    mounted() {  
        EventBus.$on('postcreator/uploadFile', this.uploadFile);
        try {
            console.log('this.mode',this.mode)
            switch (this.mode) {
       
                case 'edit': {

                    this.dataEditPost = this.$store.getters['postCreator/getDataEditPost'];
                    if (this.dataEditPost.draft && this.dataEditPost.draft.saveAllFormData && this.dataEditPost.draft.files) {
                        this.files = this.dataEditPost.draft.files
                        this.saveAllFormData = this.dataEditPost.draft.saveAllFormData
                        this.formData = this.dataEditPost.draft.saveAllFormData.main
                        //enlever de la section les pages déja publié, regarder dans saveAllFormData.page[id] ou dans saveAllFormData.networks[]
                        this.$store.commit('selectPage/updateSelectPagePageSelected', this.dataEditPost.posts.map(post => this.allPages.find(page => page.id == post.page)).filter(page => page || false));

                        EventBus.$on('postcreator/deletePostFromClickSelectPage', this.deletePostFromClickSelectPage);
                    }else{
                        throw new Error("Edition impossible");
                    }
                    break;
                }
                case 'duplicate': {
                    const dataDuplicatePost = this.$store.getters['postCreator/getDataDuplicatePost'];
                    if (dataDuplicatePost.draft && dataDuplicatePost.draft.saveAllFormData && dataDuplicatePost.draft.files) {
                        this.files = dataDuplicatePost.draft.files
                        this.saveAllFormData = dataDuplicatePost.draft.saveAllFormData
                        this.formData = dataDuplicatePost.draft.saveAllFormData.main
                        this.$store.commit('selectPage/updateSelectPagePageSelected', dataDuplicatePost.pages.map(pageId => this.allPages.find(page => page.id == pageId)).filter(page => page || false));
                    }else{
                        throw new Error("Duplication impossible");
                    }
                    break;
                }
                case 'draft': {
                    this.draft = this.$store.getters['postCreator/getDataDraft'];
                    if (this.draft.id && this.draft.data.saveAllFormData && this.draft.data.files) {
                        this.files = this.draft.data.files
                        this.saveAllFormData =  this.draft.data.saveAllFormData
                        this.formData = this.draft.data.saveAllFormData.main
                        this.$store.commit('selectPage/updateSelectPagePageSelected', this.draft.data.pages.map(pageId => this.allPages.find(page => page.id == pageId)).filter(page => page || false));
                    }else{
                        throw new Error("Impossible de charger le draft");
                    }
                    break;
                }
                default: {
                    throw new Error("Impossible de charger le mode");
                }
                    
            }
        } catch (error) {
            this.$router.push('/dash/postCreator');
        }
    },

    methods: {
        changeTab(tabName) {
            if (!['standard', 'story','story_share'].includes(tabName)) return
            this.tab = tabName
            this.tabChosen = null
        },

        async uploadFile(cbFinish, files, uplaodInstantly = false, idFiles, cbFinshLocal) {
            const fileMultiple = files instanceof FileList || Array.isArray(files)

            if (files instanceof FileList) {
                files = Array.from(files);
            } else if (!Array.isArray(files)) {
                files = [files]
            }

            if (idFiles && !Array.isArray(idFiles)) idFiles = [idFiles]

            const promises = files.map(async (file, index) => {
                console.log("uploadFile file", file)
                let idFile = idFiles && idFiles[index] ? idFiles[index] : Math.random().toString(36).substr(2, 9);

                if (this.files[idFile] && (uplaodInstantly == false || this.files[idFile].isUpload)) {
                    return this.files[idFile];
                }

                //if arg file is url blob else convert file
                if (typeof file === "string" && file.startsWith("blob:")) {
                    const response = await fetch(file);
                    const blob = await response.blob();
                    file = new File([blob], "uploaded-file", { type: blob.type });
                }

                let url, info, errorNetwork;
                if (this.files[idFile]) {
                    url = this.files[idFile].url;
                    info = this.files[idFile].info;
                    errorNetwork = this.files[idFile].errorNetwork;
                } else {
                    url = URL.createObjectURL(file);
                    info = await getInfoFile(file, url);
                    errorNetwork = getErrorNetworkFile(info);
                }

                const fileData = {
                    id: idFile,
                    url,
                    info,
                    errorNetwork: errorNetwork,
                    isUpload: false,
                    failedUpload: false,
                    uploadProgress: uplaodInstantly,
                    percentUpload: 0
                };

            
                if (!this.files[idFile]) {
                    this.$set(this.files, idFile, fileData);
                }

                if (cbFinshLocal && index == files.length - 1) cbFinshLocal();      

                if (!uplaodInstantly) {
                    return this.files[idFile];
                }
              
                return new Promise(async (resolve, reject) => {
                    const formData = new FormData();
                    formData.append('file', file);

                    const userId = JSON.parse(localStorage.user).id;
                    const source = new SSE(
                        `${process.env.VUE_APP_VIDEO_API_HOST}/image/progress?u=${userId}`,
                        { payload: formData }
                    );

                    source.onopen = () => {
                        console.log('test',this.files[idFile])
                        this.$set(this.files[idFile], 'percentUpload', 1);
                    };
                    source.onmessage = (event) => {
                        let response = JSON.parse(event.data);
                        if (response.file_url) {
                            this.$set(this.files, idFile, {
                                ...this.files[idFile],
                                isUpload: true,
                                uploadProgress: false,
                                percentUpload: 100,
                                url: response.file_url
                            });
                            if (file.type.split('/')[0] == "image") this.compressImage(response.file_url);
                            source.close();
                            resolve(this.files[idFile]);
                        } else if (response.percent) {
                            this.$set(this.files[idFile], 'percentUpload', response.percent);
                        } else if (response.error) {
                            this.$set(this.files[idFile], 'uploadProgress', false);
                            this.$set(this.files[idFile], 'failedUpload', response.error);
                            reject(this.files[idFile]);
                        }
                    };
                    source.stream((progress) => {
                        if (progress.lengthComputable) {
                            this.$set(this.files[idFile], 'percentUpload', (progress.loaded / progress.total) * 100);
                        }
                    });
                });
            });

            const results = await Promise.all(promises)
            console.log('results',results)
            if (cbFinish) cbFinish(fileMultiple ? results : results[0]);            
        },

        generateFormData(pageOrNetwork = null) {
            console.log("test12 generateFormData", pageOrNetwork)
            let formDataRef = deepClone(this.saveAllFormData.main)
            if (pageOrNetwork) {
                if(typeof pageOrNetwork === 'object' && pageOrNetwork.id){
                    //page
                    if (this.saveAllFormData.networks[pageOrNetwork.network]) mergeUpdates(formDataRef,this.saveAllFormData.networks[pageOrNetwork.network])
                    if (this.saveAllFormData.pages[pageOrNetwork.id]) mergeUpdates(formDataRef,this.saveAllFormData.pages[pageOrNetwork.id])
                }else {
                    //network
                    mergeUpdates(formDataRef,this.saveAllFormData.networks[pageOrNetwork])
                }
            }
            this.formData = formDataRef
        },

        restoreFormData(path, pageOrNetwork) {
            console.log("test12 restoreFormData",path, pageOrNetwork)
            if (!pageOrNetwork || !path) return

            if (!Array.isArray(path)) path = [path]
  
            if(typeof pageOrNetwork === 'object' && pageOrNetwork.id){
                //est une page
                if (this.saveAllFormData.pages[pageOrNetwork.id]) {
                    this.$delete(
                        [pageOrNetwork.id, ...path].slice(0,-1).reduce((acc, key) => acc[key], this.saveAllFormData.pages), 
                        path.slice(-1)[0]
                    )
                } this.$delete(this.saveAllFormData.pages[pageOrNetwork.id], path)
            }else{
                //est un network
                if (this.saveAllFormData.networks[pageOrNetwork]) {
                    this.$delete(
                        [pageOrNetwork, ...path].slice(0,-1).reduce((acc, key) => acc[key], this.saveAllFormData.networks), 
                        path.slice(-1)[0]
                    )
                }
            }    

            this.generateFormData(pageOrNetwork)    
        },

        saveFormData(pageOrNetwork) {
            if (!pageOrNetwork) {
                this.$set(this.saveAllFormData, 'main', deepClone(this.formData))
            }else{
                let formDataRef = deepClone(this.saveAllFormData.main)
                if(typeof pageOrNetwork === 'object' && pageOrNetwork.id){
                     // pageOrNetwork est une page
                    if (this.saveAllFormData.networks[pageOrNetwork.network]) mergeUpdates(formDataRef, this.saveAllFormData.networks[pageOrNetwork.network])
                    const update = findDifferences(formDataRef, this.formData)
                    this.$set(this.saveAllFormData.pages, pageOrNetwork.id, update)
                } else {
                    // pageOrNetwork est un network
                    const update = findDifferences(formDataRef, this.formData)
                    this.$set(this.saveAllFormData.networks, pageOrNetwork, update)
                } 
            }   
        },

        generateDraft(saveAllFormData, pages) {
          
            saveAllFormData = JSON.parse(JSON.stringify(saveAllFormData))
 
            const replaceMentionsInTextDefault = (text, mentions) => {
                return text.trim().replace(/@(\d{13})/g, (match, id) => {
                    const mention = mentions[id];
                    if (mention) {
                        return mention.textDefault || '';
                    }
                    return match;
                });
            }

            const currentDate = new Date()
            let draft = {}

            draft.saveAllFormData = saveAllFormData
            draft.files = Object.fromEntries(Object.entries(this.files).filter(([idFile,dataUpload]) => dataUpload.isUpload))
            draft.form = {
                page : 0,
                name : null,
                url: null,
                file: null,
                date: null,
                time: null,
                title: replaceMentionsInTextDefault(unescapeSpecialChars(saveAllFormData.main.textContent.slice(0, 100).split("\\n")[0]), saveAllFormData.main.mentions),
            },

    
            draft.scheduling = {
                "lastScheduled": null,
                "show":true,
                "date": saveAllFormData.main.planifiedDate && saveAllFormData.main.planifiedDate.date ? 
                    new Date(`${saveAllFormData.main.planifiedDate.date}T${saveAllFormData.main.planifiedDate.hours.replace('h',':')}:00`).toISOString() 
                    : 
                    currentDate.toISOString(),
                "time":{
                    "HH": saveAllFormData.main.planifiedDate.hours ? saveAllFormData.main.planifiedDate.hours.split('h')[0] : String(currentDate.getHours()),
                    "mm": saveAllFormData.main.planifiedDate.hours ? saveAllFormData.main.planifiedDate.hours.split('h')[1] : String(currentDate.getMinutes())
                }
            }
            draft.scheduling.lastScheduled = draft.scheduling.date

            draft.pages = pages.map(page => page.id)
            draft.bot = pages.map(page => page.bots && page.bots.length && page.bots[0].id ? page.bots[0].id : null)

            //enclosure
            
            const enclosureFile = saveAllFormData.main.files.find(file => this.files[file.id].info.type2 == 'image' && file.type == 'image/gif' && this.files[file.id].isUpload && this.files[file.id].url) 
            || saveAllFormData.main.files.find(file => this.files[file.id].info.type2 == 'video' && this.files[file.id].isUpload && this.files[file.id].url)
            || saveAllFormData.main.files.find(file => this.files[file.id].info.type2 == 'image' && this.files[file.id].isUpload && this.files[file.id].url)

            if (enclosureFile) {
                if (this.files[enclosureFile.id].info.type2 == 'video') {
                    draft.form.video = this.files[enclosureFile.id].url
                }else{
                    draft.form.enclosure = this.files[enclosureFile.id].url
                }
            }
            draft.editPostValue = []

            pages.forEach(page => {

                let formDataRef = deepClone(saveAllFormData.main)
                if (saveAllFormData.networks[page.network]) mergeUpdates(formDataRef,saveAllFormData.networks[page.network])
                if (saveAllFormData.pages[page.id]) mergeUpdates(formDataRef,saveAllFormData.pages[page.id])
                

                let edit = {
                    page : page.id
                }

                if (saveAllFormData.main.planifiedDate.date !== formDataRef.planifiedDate.date || saveAllFormData.main.planifiedDate.hours !== formDataRef.planifiedDate.hours) {
                    if (!formDataRef.planifiedDate.date || !formDataRef.planifiedDate.hours) {
                        edit.scheduling = {
                            "date": currentDate.toISOString(),
                            "time":{
                                "HH": String(currentDate.getHours()),
                                "mm": String(currentDate.getMinutes())
                            }
                        }
                    }else{
                        edit.scheduling = {
                            "date": new Date(`${formDataRef.planifiedDate.date}T${formDataRef.planifiedDate.hours.replace('h',':')}:00`).toISOString(),
                            "time":{
                                "HH": formDataRef.planifiedDate.hours.split('h')[0],
                                "mm": formDataRef.planifiedDate.hours.split('h')[1]
                            }
                        }
                    }
                }

                if (saveAllFormData.main.textContent !== formDataRef.textContent) {
                    edit.title = replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent.slice(0, 100).split("\\n")[0]), formDataRef.mentions)
                }
                

                edit.video = null
                edit.enclosure = null

                const files = getFilesByNetwork(formDataRef.files, [page.network], {[page.network]: formDataRef.formDataNetwork[page.network]}, this.files, true)[page.network]
                
                if (files && files.length) {
                    
                    const fileFind = files.find(file => file.type2 == 'image' && file.type == 'image/gif' && this.files[file.id].isUpload && this.files[file.id].url) 
                    || files.find(file => file.type2 == 'video' && this.files[file.id].isUpload && this.files[file.id].url)
                    || files.find(file => file.type2 == 'image' && this.files[file.id].isUpload && this.files[file.id].url)

                    if (fileFind) {
                        if (fileFind.type2 == 'video') {
                            edit.video = this.files[fileFind.id].url
                        }else{
                            edit.enclosure = this.files[fileFind.id].url
                        }
                    }
                }


                if (Object.keys(edit).length > 1) {
                    draft.editPostValue = [...draft.editPostValue, edit]
                }
                

            });  

            return draft   
        },

        async generateDataFormRequest(cb) {
            

            const getErrorObject = (text) => {
                console.log("getErrorObject")
                throw new Error(text)
            };

            const replaceMentionsInTextDefault = (text, mentions) => {
                return text.trim().replace(/@(\d{13})/g, (match, id) => {
                    const mention = mentions[id];
                    if (mention) {
                        return mention.textDefault || '';
                    }
                    return match;
                });
            }

            const pagesSelected = this.tab == 'story' ? this.pagesSelected.filter(page => page.network == 'instagram') : this.pagesSelected
            
            const pagesDataForm =  await Promise.all(pagesSelected.map(async page => {
                try {
                    if (!page.bots[0] || !page.bots[0].id) return getErrorObject("Les services de cette page ne sont pas activés, veuillez reconnecter la ou contacter un administrateur")

                    let formDataRef = deepClone(this.saveAllFormData.main)
                    if (this.saveAllFormData.networks[page.network]) mergeUpdates(formDataRef,this.saveAllFormData.networks[page.network])
                    if (this.saveAllFormData.pages[page.id]) mergeUpdates(formDataRef,this.saveAllFormData.pages[page.id])
                  
                    const dataFormRequest = {
                        bot: page.bots[0].id,
                        service: 'dashboard',
                        scheduled : formDataRef.planifiedDate && formDataRef.planifiedDate.date ? true : false,
                        'data[allBots]' : pagesSelected.map(page => page.bots && page.bots.length && page.bots[0].id ? page.bots[0].id : null).join(','),
                        'data[videoType]' : page.network,
                        'data[scheduled_date]' : formDataRef.planifiedDate && formDataRef.planifiedDate.date ? new Date(`${formDataRef.planifiedDate.date}T${formDataRef.planifiedDate.hours.replace('h',':')}:00`).toISOString() : undefined,
                    }

                    const formNetwork = formDataRef.formDataNetwork[page.network]
                    let files = getFilesByNetwork(formDataRef.files, [page.network], {[page.network]: formDataRef.formDataNetwork[page.network]}, this.files, true)[page.network]
                    
                    if (this.tab == 'story') {
                   
                        // dataFormRequest['data[storification]'] =  JSON.stringify(formDataRef.storification)
                    }else{
                        const postValidator =  postNetworkValidator([page.network], {[page.network]: files}, {[page.network]: formDataRef.formDataNetwork[page.network]}, unescapeSpecialChars(formDataRef.textContent))
                        if (!postValidator[page.network].isValid) {
                            return getErrorObject(postValidator[page.network].error[0].textError)
                        }
                   
                        switch (page.network) {
                            case 'instagram': {

                                const replaceMentions = (text, mentions) => {
                                    return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                        const mention = mentions[id];
                                        if (mention) {
                                            return mention.mention && mention.mention.instagram ? `@${mention.mention.instagram.id}` : mention.textDefault;
                                        }
                                        return match;
                                    });
                                }
                            
                                dataFormRequest['data[title]'] = replaceMentions(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions);

                                if (formDataRef.textComment && formDataRef.textComment.trim().length) {
                                    dataFormRequest["data[comments]"] = JSON.stringify([replaceMentions(unescapeSpecialChars(formDataRef.textComment), formDataRef.mentions)]);
                                }

                                if (formNetwork.collaborators.length || formNetwork.personsIdentified.length) {
                                    dataFormRequest['data[userTags]'] = JSON.stringify({
                                        list : formNetwork.collaborators.concat(formNetwork.personsIdentified).reduce((unique, mention) => {
                                                if(!unique.some(obj => obj.id === mention.id)) {
                                                    const index = files.findIndex(file => file.id == mention.idFile)
                                                    unique.push({
                                                        name : mention.name,
                                                        x : String(mention.x/100),
                                                        y : String(mention.y/100),
                                                        username: mention.id,
                                                        id: mention.pk,
                                                        index : index >= 0 ? index : 0
                                                    });
                                                }
                                                return unique;
                                            },[]),
                                        collab : formNetwork.collaborators.length ? [formNetwork.collaborators[0].pk] : []
                                    })
                                }
                                
                                
                                if (formNetwork.place && formNetwork.place.id) {
                                    dataFormRequest['data[location]'] = formNetwork.place.id
                                }

                                if (files.length > 0 && files[0].type2 === "image") {
                                    dataFormRequest['data[enclosure]'] = this.files[formDataRef.files[0].id].url;   
                                }

                                if (files.length == 1 && files[0].type2 === "video") {

                                    dataFormRequest['data[videoReel]'] = true //pas obligatoire, marche sans
                                    dataFormRequest['data[video]'] = this.files[files[0].id].url

                                    if (formNetwork.music) {
                                        let duration;
                                        try {
                                            duration = await getVideoDuration(this.files[files[0].id].url) * 1000
                                        } catch (error) {
                                            console.error('Erreur lors de la récupération de la durée:', error);
                                            duration = 0
                                        } 

                                        dataFormRequest['data[reelStickerConfig]'] = JSON.stringify({
                                            "texts":[],
                                            "music" : {
                                                ...formNetwork.music,
                                                "duration":duration,
                                                "startTime": formNetwork.music.track.highlight_start_times_in_ms[0],
                                                "start": formNetwork.music.track.highlight_start_times_in_ms[0],
                                                "end": formNetwork.music.track.highlight_start_times_in_ms[0] + duration,
                                                "config":false,
                                                "paused":true,
                                                
                                            
                                            },
                                            "gifs" :[]
                                        })
                                    }
                                } else {

                                    if (files.find(file => file.type2 == "video")) {
                                        dataFormRequest['data[typePost]'] = 'video'
                                        dataFormRequest['data[postImage]'] = false
                                        dataFormRequest['data[multipleMedias]'] = JSON.stringify(
                                            files.map((file, index) => {
                                                return {
                                                    id: file.id,
                                                    url: this.files[file.id].url,
                                                    name: file.filename,
                                                    type: file.type,
                                                    size: file.size,
                                                };
                                            }),
                                        );
                                    }else{
                                        dataFormRequest['data[carrousel]'] = JSON.stringify(
                                            files.map((file, index) => {
                                                return {
                                                    url: this.files[file.id].url,
                                                    filename: file.filename,
                                                    ratio: String(formNetwork.ratio == '16:9' ? 1.91 : formNetwork.ratio.split(':').reduce((a, b) => a / b)),
                                                    facebook: index,//? ne sert a rien
                                                    twitter: index,//? ne sert a rien
                                                    linkedin: index,//? ne sert a rien
                                                    uploaded: true
                                                };
                                            }),
                                        );
                                    }
                            
                                }

                                if (formNetwork.shareInStory) {
                                    // dataFormRequest['data[background_color]'] = '#dcd2ce'
                                    dataFormRequest['data[postcreator]'] = true
                                    dataFormRequest['data[storification]'] =  JSON.stringify(formDataRef.storification)
                                }
                                break;
                            }
                            case 'facebook': {
                                const replaceFacebookMentions = (text, mentions) => {
                                    return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                        const mention = mentions[id];
                                        if (mention) {
                                            return mention.mention && mention.mention.facebook 
                                                ? `@[${mention.mention.facebook.name} (${mention.mention.facebook.id})]` 
                                                : mention.textDefault;
                                        }
                                        return match;
                                    });
                                }

                                
                                dataFormRequest['data[title]'] = replaceFacebookMentions(
                                    unescapeSpecialChars(formDataRef.textContent), 
                                    formDataRef.mentions
                                );

                                
                                if (formDataRef.textComment && formDataRef.textComment.trim().length) {
                                    dataFormRequest["data[comments]"] = JSON.stringify([
                                        replaceFacebookMentions(
                                            unescapeSpecialChars(formDataRef.textComment), 
                                            formDataRef.mentions
                                        )
                                    ]);
                                }


                                if (formNetwork.place && formNetwork.place.id) {
                                    dataFormRequest['data[location]'] = formNetwork.place.id
                                }

                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                        dataFormRequest['data[url]'] = formNetwork.snippet.link
                                        dataFormRequest['data[postImage]'] = false
                                        dataFormRequest['data[videoType]'] = 'facebook'
                                        dataFormRequest['data[typePost]'] = 'standard'
                                }else{
                                    if (formNetwork.typeMedia == 'image') {

                                        if (files.length == 1) {
                                            dataFormRequest['data[postImage]'] = true
                                            dataFormRequest['data[typePost]'] = 'image'
                                            dataFormRequest['data[enclosure]'] = this.files[files[0].id].url
                                        }

                                        if (files.length > 1) {
                                            dataFormRequest['data[postImage]'] = true
                                            dataFormRequest['data[typePost]'] = 'image'
                                            dataFormRequest['data[carrousel]'] = 'image'

                                            dataFormRequest['data[carrousel]'] = JSON.stringify(
                                                files.map((file, index) => {
                                                
                                                    return {
                                                        url: this.files[file.id].url,
                                                        filename: file.filename,
                                                        size: file.size,
                                                        id: file.id,
                                                        ratio : 1,//? ne sert a rien
                                                        facebook: index,//? ne sert a rien
                                                        twitter: index,//? ne sert a rien
                                                        linkedin: index,//? ne sert a rien
                                                        uploaded: true
                                                    };
                                                }),
                                            );
                                        }
                                    
                                    }

                                    if (formNetwork.typeMedia == 'video') {
                
                                        const file = formDataRef.files.find(file => file.type2 == 'video')
                                    
                                        if (file) {
                                            dataFormRequest['data[postImage]'] = false
                                            dataFormRequest['data[videoType]'] = 'facebook'
                                            dataFormRequest['data[typePost]'] = 'video'
                                            dataFormRequest['data[video]'] =  this.files[file.id].url

                                            if (file.imagePreview && file.imagePreview.id && this.files[file.imagePreview.id] && this.files[file.imagePreview.id].isUpload) {
                                                dataFormRequest['data[enclosure]'] = this.files[file.imagePreview.id].url
                                            }
                                        }
                                    
                                    }    
                                }
                                break;
                            }
                            case 'linkedin' : {

                                const replaceLinkedInMentions = (text, mentions) => {
                                    return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                        const mention = mentions[id];
                                        if (mention) {
                                            return mention.mention && mention.mention.linkedin 
                                                ? `@[${mention.mention.linkedin.name} (${mention.mention.linkedin.id})]` 
                                                : mention.textDefault;
                                        }
                                        return match;
                                    });
                                }

                                dataFormRequest['data[title]'] = replaceLinkedInMentions(
                                    unescapeSpecialChars(formDataRef.textContent), 
                                    formDataRef.mentions
                                );

                                if (formDataRef.textComment && formDataRef.textComment.trim().length) {
                                    dataFormRequest["data[comments]"] = JSON.stringify([
                                        replaceLinkedInMentions(
                                            unescapeSpecialChars(formDataRef.textComment), 
                                            formDataRef.mentions
                                        )
                                    ]);
                                }
                                                        

                                if (formNetwork.survey && formNetwork.survey.active) {
                                    dataFormRequest['data[postImage]'] = false
                                    dataFormRequest['data[videoType]'] = 'linkedin'
                                    dataFormRequest['data[typePost]'] = 'poll'
                                    dataFormRequest['data[poll]'] =  JSON.stringify({
                                        question : formNetwork.survey.question,
                                        options : formNetwork.survey.options,
                                        duration : { 
                                            oneDay : 86400,
                                            threeDay : 259200,
                                            oneWeek : 604800,
                                            twoWeek : 1209600
                                        }[formNetwork.survey.duration]
                                    })
                                    // ajout d'un sondage

                                }else{

                                    if (formNetwork.snippet && formNetwork.snippet.link) {
                                        dataFormRequest['data[url]'] = formNetwork.snippet.link
                                        dataFormRequest['data[postImage]'] = false
                                        dataFormRequest['data[videoType]'] = 'linkedin'
                                        dataFormRequest['data[typePost]'] = 'standard'
                                    }else if (files.length) {
                                        if (formNetwork.typeMedia == 'video') {
                                            const file = files.find(file => file.type2 == 'video')
                    
                                            if (file) {
                                                dataFormRequest['data[postImage]'] = false
                                                dataFormRequest['data[videoType]'] = 'linkedin'
                                                dataFormRequest['data[typePost]'] = 'video'
                                                dataFormRequest['data[video]'] =  this.files[file.id].url

                                                if (file.imagePreview && file.imagePreview.id && this.files[file.imagePreview.id] && this.files[file.imagePreview.id].isUpload) {
                                                    dataFormRequest['data[enclosure]'] = this.files[file.imagePreview.id].url
                                                }
                                            }
                                        
                                        }

                                        if (formNetwork.typeMedia == 'image') {

                                            if (files.length == 1) {
                                                dataFormRequest['data[postImage]'] = true
                                                dataFormRequest['data[typePost]'] = 'image'
                                                dataFormRequest['data[videoType]'] = 'linkedin'
                                                dataFormRequest['data[enclosure]'] = this.files[files[0].id].url
                                            }

                                            if (files.length > 1) {
                                                dataFormRequest['data[postImage]'] = true
                                                dataFormRequest['data[typePost]'] = 'image'
                                                dataFormRequest['data[carrousel]'] = 'image'
                                                dataFormRequest['data[videoType]'] = 'linkedin'

                                                dataFormRequest['data[carrousel]'] = JSON.stringify(
                                                    files.map((file, index) => {
                                                        if (!dataFormRequest['data[enclosure]']) {
                                                            dataFormRequest['data[enclosure]'] = this.files[file.id].url
                                                        }
                                                    
                                                        return {
                                                            url: this.files[file.id].url,
                                                            filename: file.filename,
                                                            file : {
                                                                id: file.id,
                                                            },
                                                            size: file.size,
                                                            id: file.id,
                                                            ratio : 1,//? ne sert a rien
                                                            facebook: index,//? ne sert a rien
                                                            twitter: index,//? ne sert a rien
                                                            linkedin: index,//? ne sert a rien
                                                            uploaded: true
                                                        };
                                                    }),
                                                );
                                            }
                                        }

                                        if (formNetwork.typeMedia == 'pdf') {
                                            dataFormRequest['data[postImage]'] = false
                                            dataFormRequest['data[videoType]'] = 'linkedin'
                                            dataFormRequest['data[typePost]'] = 'document'
                                            dataFormRequest['data[documentTitle]'] = formNetwork.pdf && formNetwork.pdf.title ? formNetwork.pdf.title : files[0].name
                                            dataFormRequest['data[enclosure]'] = this.files[files[0].id].url
                                            
                                        }
                                    }
                                }

                                break;
                            }
                            case 'google':{
                                dataFormRequest['data[postImage]'] = true
                                dataFormRequest['data[videoType]'] = 'google'
                                dataFormRequest['data[typePost]'] = 'image'

                                dataFormRequest['data[title]'] = replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions)
                            
                                if (files.length) {
                                    dataFormRequest['data[enclosure]'] = this.files[files[0].id].url
                                }else{
                                    if (formNetwork.snippet && formNetwork.snippet.link) {
                                        try {
                                            const { body } = await this.getNewsMeta(formNetwork.snippet.link)
                                            const imageUrl = body.meta.og && body.meta.og.image ? body.meta.og.image : body.meta.image && body.meta.image[0] ? body.meta.image[0].url : null
                                            if (!imageUrl) return getErrorObject("Veuillez ajouter au moins une image ou un lien.")
                                            dataFormRequest['data[enclosure]'] = imageUrl
                                        } catch (error) {
                                            return getErrorObject("Veuillez ajouter au moins une image ou un lien.")
                                        }
                                    }
                                }

                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest['data[url]'] = formNetwork.snippet.link
                                }
                                break;
                            }
                            case 'threads': {
                                dataFormRequest['data[title]'] = replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions)
                                
                                if (formDataRef.textComment && formDataRef.textComment.trim().length) {
                                    dataFormRequest["data[comments]"] = JSON.stringify([replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textComment), formDataRef.mentions)])
                                }


                                if (!formDataRef.urlsTextContent.length && formNetwork.snippet && formNetwork.snippet.link) {
                                        dataFormRequest['data[url]'] = formNetwork.snippet.link
                                        dataFormRequest['data[postImage]'] = false
                                        dataFormRequest['data[videoType]'] = 'threads'
                                        dataFormRequest['data[typePost]'] = 'standard'
                                }else{
                                
                                    if (files.length == 1) {
                                    
                                        if (files[0].type2 == 'image') {
                                            dataFormRequest["data[postImage]"] = true
                                            dataFormRequest["data[videoType]"] = 'threads'
                                            dataFormRequest["data[typePost]"] = 'image'
                                            dataFormRequest['data[enclosure]'] = this.files[files[0].id].url
                                        }else if(files[0].type2 == 'video') {
                                            dataFormRequest["data[postImage]"] = false
                                            dataFormRequest["data[videoType]"] = 'threads'
                                            dataFormRequest["data[typePost]"] = 'video'
                                            dataFormRequest['data[video]'] = this.files[files[0].id].url
                                        }
                                    }else {
                                        dataFormRequest["data[postImage]"] = false

                                        if (files.find(file => file.type2 == 'video') && files.find(file => file.type2 == 'image')) {
                                            dataFormRequest['data[enclosure]'] = this.files[files.find(file => file.type2 == 'image').id].url
                                            dataFormRequest["data[postImage]"] = false
                                            dataFormRequest['data[video]'] = this.files[files.find(file => file.type2 == 'video').id].url
                                            dataFormRequest["data[videoType]"] = 'threads'
                                            dataFormRequest["data[typePost]"] = 'video'

                                            dataFormRequest["data[multipleMedias]"] =  JSON.stringify(files.map((file) => {
                                                return {
                                                    id: file.id,
                                                    url: this.files[file.id].url,
                                                    name: file.name,
                                                    type: file.type,
                                                    size: file.size,
                                                }
                                            }))

                                        }else if (files.find(file => file.type2 == 'video')) {
                                            dataFormRequest["data[postImage]"] = false
                                            dataFormRequest['data[video]'] = this.files[files.find(file => file.type2 == 'video').id].url
                                            dataFormRequest["data[videoType]"] = 'threads'
                                            dataFormRequest["data[typePost]"] = 'video'

                                            dataFormRequest["data[multipleMedias]"] =  JSON.stringify(files.map((file) => {
                                                return {
                                                    id: file.id,
                                                    url: this.files[file.id].url,
                                                    name: file.name,
                                                    type: file.type,
                                                    size: file.size,
                                                }
                                            }))

                                        }else if (files.find(file => file.type2 == 'image')) {
                                            dataFormRequest['data[enclosure]'] = this.files[files[0].id].url
                                            dataFormRequest["data[postImage]"] = true
                                            dataFormRequest["data[videoType]"] = 'threads'
                                            dataFormRequest["data[typePost]"] = 'image'

                                            dataFormRequest["data[carrousel]"] =  JSON.stringify(files.map((file,index) => {

                                                return {
                                                    url: this.files[file.id].url,
                                                    filename: file.name,
                                                    file: {
                                                        id: file.id
                                                    },
                                                    size: file.size,
                                                    id: file.id,
                                                    ratio: 1,
                                                    facebook: index,
                                                    twitter: index,
                                                    linkedin: index,
                                                    uploaded: true
                                                }
                                            }))
                                        }
                                    }
                                } 
                            

                            

                                break;
                            }
                            case 'twitter': {
                            
                                const replaceTwitterMentions = (text, mentions) => {
                                    return text.trim().replace(/@(\d{13})/g, (match, id) => {
                                        const mention = mentions[id];
                                        if (mention) {
                                            return mention.mention && mention.mention.twitter 
                                                ? `@${mention.mention.twitter.username}` 
                                                : mention.textDefault;
                                        }
                                        return match;
                                    });
                                }

                                dataFormRequest['data[title]'] = replaceTwitterMentions(
                                    unescapeSpecialChars(formDataRef.textContent), 
                                    formDataRef.mentions
                                );

                                if (formDataRef.textComment && formDataRef.textComment.trim().length) {
                                    dataFormRequest["data[comments]"] = JSON.stringify([
                                        replaceTwitterMentions(
                                            unescapeSpecialChars(formDataRef.textComment), 
                                            formDataRef.mentions
                                        )
                                    ]);
                                }

                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest["data[url]"] = formNetwork.snippet.link
                                    dataFormRequest["data[postImage]"] = false
                                    dataFormRequest["data[videoType]"] = 'twitter'
                                    dataFormRequest["data[typePost]"] = 'standard'

                                }else if(files.length){

                                    if (files[0].type2 == 'image') {

                                        if (files.length == 1) {
                                            dataFormRequest["data[postImage]"] = true
                                            dataFormRequest["data[videoType]"] = 'twitter'
                                            dataFormRequest["data[typePost]"] = 'image'
                                            dataFormRequest['data[enclosure]'] = this.files[files[0].id].url
                                        }else{
                                        
                                            dataFormRequest["data[postImage]"] = true
                                            dataFormRequest['data[enclosure]'] = this.files[files.find(file => file.type2 == 'image').id].url
                                            dataFormRequest["data[videoType]"] = 'twitter'
                                            dataFormRequest["data[typePost]"] = 'image'

                                            dataFormRequest["data[carrousel]"] =  JSON.stringify(files.map((file, index) => {

                                                return {
                                                    url: this.files[file.id].url,
                                                    filename: file.name,
                                                    file: {
                                                        id: file.id,
                                                    },
                                                    size: file.size,
                                                    id: file.id,
                                                    ratio: 1,
                                                    facebook: index,
                                                    twitter: index,
                                                    linkedin: index,
                                                    uploaded: true
                                                }
                                            }))
                                        }

                                    }else if (files[0].type2 == 'video') {
                                        dataFormRequest["data[postImage]"] = false
                                        dataFormRequest["data[videoType]"] = 'twitter'
                                        dataFormRequest["data[typePost]"] = 'video'
                                        dataFormRequest['data[video]'] = this.files[files[0].id].url
                                    }
                                }

                                break;
                            }
                            case 'tiktok': {
                            
                                dataFormRequest['data[title]'] = replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions)

                                dataFormRequest['data[postImage]'] = false
                                dataFormRequest['data[video]'] = this.files[files[0].id].url
                                dataFormRequest['data[typePost]'] = 'video'
                                dataFormRequest['data[videoType]'] = 'tiktok'
                                dataFormRequest['data[tiktokOptions]'] = JSON.stringify(
                                    {
                                        comment_disabled: formNetwork.commentDisable,
                                        duet_disabled: formNetwork.useVideoForDuo,
                                        stitch_disabled: formNetwork.useVideoForOtherVideo,
                                        privacy_level: {
                                            all: 'PUBLIC_TO_EVERYONE',
                                            friends: 'MUTUAL_FOLLOW_FRIENDS',
                                            me: 'SELF_ONLY',
                                        }[formNetwork.visibility],
                                    
                                    }
                                )
                            
                                break;
                            }
                            case 'youtube': {

                                dataFormRequest['data[title]'] = replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent.slice(0, 100).split("\\n")[0]), formDataRef.mentions)
                                
                                dataFormRequest['data[description]'] = replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent.split("\\n").slice(1).join("\\n")), formDataRef.mentions)

                                dataFormRequest['data[postImage]'] = false
                                dataFormRequest['data[video]'] = this.files[files[0].id].url
                                dataFormRequest['data[videoType]'] = 'youtube'
                                dataFormRequest['data[typePost]'] = 'video'

                                dataFormRequest['data[youtubeOption]'] = JSON.stringify({
                                    notifySubscribers: formNetwork.notifySubscribers,
                                    madeForKids: formNetwork.contentForChildren,
                                    privacy_level: {
                                        all: "public",
                                        private: "private",
                                        unlisted: "unlisted"
                                    }[formNetwork.visibility],
                                    category: formNetwork.category,
                                    tag : '', //inutile
                                    tags : formNetwork.tags.length ? formNetwork.tags.map(tagName => ({
                                            text: tagName,
                                            tiClasses : ["valid"]
                                        }))
                                        : [],
                                    playlist: formNetwork.playlistSelectedByPage[page.id] ? formNetwork.playlistSelectedByPage[page.id] : null
                                })

                            
                                break;
                            }
                            case 'pinterest': {
                                
                                if (!formNetwork.boardSelectedByPage[page.id]) return getErrorObject("Aucun board n'a été sélectionné")
                                dataFormRequest['data[boardSelected]'] = formNetwork.boardSelectedByPage[page.id]

                                if (formNetwork.snippet && formNetwork.snippet.link) {
                                    dataFormRequest['data[url]'] = formNetwork.snippet.link
                                }

                                if (!files[0]) {
                                    try {
                                        const { body } = await this.getNewsMeta(formNetwork.snippet.link)
                                        const imageUrl = body.meta.og && body.meta.og.image ? body.meta.og.image : body.meta.image && body.meta.image[0] ? body.meta.image[0].url : null
                                        if (!imageUrl) return getErrorObject("Veuillez ajouter au moins une image ou un lien")

                                        dataFormRequest['data[enclosure]'] = imageUrl
                                        dataFormRequest['data[postImage]'] = true
                                        dataFormRequest['data[videoType]'] = 'pinterest'
                                        dataFormRequest['data[typePost]'] = 'image'

                                    } catch (error) {
                                        return getErrorObject("Veuillez ajouter au moins une image ou un lien")
                                    }
                                }

                                dataFormRequest['data[title]'] = replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent.slice(0, 100).split("\\n")[0]), formDataRef.mentions)
                                dataFormRequest['data[description]'] = replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent.split("\\n").slice(1).join("\\n")), formDataRef.mentions)

                                if (files[0]) {
                                    
                                    if (files[0].type2 == 'video') {
                                        dataFormRequest['data[postImage]'] = false
                                        dataFormRequest['data[video]'] = this.files[files[0].id].url
                                        dataFormRequest['data[videoType]'] = 'pinterest'
                                        dataFormRequest['data[typePost]'] = 'video'
                                    }else if (files[0].type2 == 'image') {
                                        dataFormRequest['data[enclosure]'] = this.files[files[0].id].url
                                        dataFormRequest['data[postImage]'] = true
                                        dataFormRequest['data[videoType]'] = 'pinterest'
                                        dataFormRequest['data[typePost]'] = 'image'
                                    }
                                
                                }
                                break;
                            }
                            case 'telegram': { 
                                dataFormRequest['data[title]'] = replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textContent), formDataRef.mentions)
                                dataFormRequest['data[videoType]'] = 'telegram'
                                dataFormRequest['data[typePost]'] = 'standard'

                                if (formDataRef.textComment && formDataRef.textComment.trim().length) {

                                    dataFormRequest["data[comments]"] = JSON.stringify([replaceMentionsInTextDefault(unescapeSpecialChars(formDataRef.textComment), formDataRef.mentions)])
                                }
                                break;
                            }
                        }
                    }

                    return [page.id, dataFormRequest]
                } catch (error) {
                    console.log('error')
                    return [page.id, {
                        error: error.message
                    }]
                }
               
            })); 

            let pagesDataFormObject = Object.fromEntries(pagesDataForm.filter(data => data !== null))

            const idPagesValid = Object.keys(pagesDataFormObject).filter(id => !pagesDataFormObject[id].hasOwnProperty('error'))
            //generer un draft avec que les pages valide
            if (idPagesValid.length) {
                const draft = JSON.stringify(this.generateDraft(
                    this.saveAllFormData, 
                    idPagesValid.map((pageId) => this.pagesSelected.find(page => page.id == pageId) || this.allPages.find(page => page.id == pageId))
                ))
                idPagesValid.forEach(id => {
                    pagesDataFormObject[id]["draft"] = draft
                });
            }
            if (cb) cb(pagesDataFormObject)
            this.dataFormRequest = pagesDataFormObject
            return pagesDataFormObject
        },

        async saveDraft() {
            
            const draft = this.generateDraft(
                this.saveAllFormData, 
                this.pagesSelected
            )

            if (this.mode == 'draft') {
                EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError, openWindow)=> {

                    try {
                        const response = await this.updateDraft({
                            ...draftTemplate,
                            ...draft, 
                            id: this.draft.id
                            
                        });

                        if (response.data.success) {
                            onSuccess(`Brouillon enregistrer avec succés`);
                            this.draft = {
                                data : draft,
                                id : this.draft.id
                            }
                            this.$store.commit('postCreator/setDataForDraft', this.draft);
                            openWindow()
                        }else{
                            throw new Error(`Échec de l'enregistrement du brouillon`);
                        }
                    } catch (error) {
                        onError(error.message);
                        openWindow()
                    }  
                }, {
                    picture: draft.form.enclosure,
                    title:`<span class="pink">Enregistrement du brouillon</span>`,
                    loadingText: "En cours'...",
                })
            }else if (this.mode == 'edit'){
                EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError, openWindow)=> {

                    try {
                        const response = await this.newDraft({
                            ...draftTemplate,
                            ...draft, 
                        });

                        if (response.data.success) {

                            const promises = this.dataEditPost.posts.map(async (post) => {
                                try {
                                    const res = await this.deletePost({
                                        _id: post._id,
                                        _bots: [{
                                            id: post.bot,
                                            page: {
                                                network: (this.pagesSelected.find((page) => page.id == post.page) || this.allPages.find((page) => page.id == post.page)).network,
                                            }
                                        }],
                                        page: [{
                                            post_number: post.postId,
                                            status: post.status
                                        }]
                                    });

                                    if (res.data.success) {
                                        return { success: true };
                                    } else {
                                        throw new Error(`Impossible de supprimer le post ${post._id}`);
                                    }
                                } catch (error) {
                                    return { success: false, error: error.message };
                                }
                            });

                            // Attendre que toutes les promesses soient résolues
                            const results = await Promise.allSettled(promises);

                            const errors = results.filter(result => result.status === 'rejected' || (result.value && !result.value.success));

                            if (errors.length > 0) {
                                if (this.dataEditPost.posts.length == 1) {
                                    onError(this.dataEditPost.posts.length > 1 ? `Attention: Un post planifié n'a pas pu etre retirer` : `Attention : Le post planifié n'a pas pû être retiré, mais le brouillon a bien été créé.`);
                                } else {
                                    onError(`Attention : Certain des post n'ont pas pû être retiré, mais le brouillon a bien été créé.`);
                                }
                            } else {
                                onSuccess(`Succès de la conversion en brouillon.`);
                            }

                            this.draft = {
                                data : draft,
                                id : response.data.draft.id
                            }
                            
                            this.$store.commit('postCreator/setDataForDraft', this.draft);
                            openWindow()
                            this.$router.push('/dash/postCreator/draft');
                        }else{
                            throw new Error(`Échec de la conversion en brouillon`);
                        }

                    } catch (error) {
                        onError(error.message);
                        openWindow()
                    }  
                    }, {
                    picture: draft.form.enclosure,
                    title:`<span class="pink">Conversion en brouillon</span>`,
                    loadingText: "En cours de conversion...",
                })
            }else{
                EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError, openWindow)=> {

                    try {
                        const response = await this.newDraft({
                           ...draftTemplate,
                            ...draft, 
                            
                        });

                        if (response.data.success) {
                            onSuccess(`Création du brouillon avec succés`);
                            this.draft = {
                                data : draft,
                                id : response.data.draft.id
                            }
                            this.$store.commit('postCreator/setDataForDraft', this.draft);
                            openWindow()
                            this.$router.push('/dash/postCreator/draft');
                        }else{
                            throw new Error(`Échec de la création du brouillon`);
                        }
                    } catch (error) {
                        onError(error.message);
                        openWindow()
                    }  
                    }, {
                    picture: draft.form.enclosure,
                    title:`<span class="pink">Mise en brouillon</span>`,
                    loadingText: "En cours de création...",
                })
            }
        },

        async sendPostAllPost() {
            const requestGroup = []
        
            switch (this.mode) {
                case 'create': {
                    for (const [pageId, formData] of Object.entries(this.dataFormRequest)) {
                        if (!formData.hasOwnProperty('error')) {
                            const page = this.pagesSelected.find(page => page.id == pageId) || this.allPages.find(page => page.id == pageId)
                            requestGroup.push({
                                start : async (onSuccess, onProgress, onError) => {
                                    try {
                                        const response = await this.new(formData);
                                        if (response.data.success) {
                                            onSuccess(`Post ${formData["data[scheduled_date]"] ? 'planifié' : 'publié'} avec succés`);
                                            return {response, formData: { ...formData, pageId }}
                                        }else{
                                            throw new Error(`Echec lors de la ${formData["data[scheduled_date]"] ? 'planification' : 'publication'} du post`);
                                        }
                                    } catch (error) {
                                        onError(error.message);
                                        return {response:null, formData: { ...formData, pageId }}
                                    }
                                },
                                params : {
                                    picture : formData["data[enclosure]"] || page.avatar,
                                    title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                                    loadingText: !formData["data[scheduled_date]"] ? "En cours de publication..." : "En cours de planification..."
                                }
                            });
                        }
                    
                    }
                    break;
                }
                case 'edit': {
                    for (const [pageId, formData] of Object.entries(this.dataFormRequest)) {
                        if (!formData.hasOwnProperty('error')) {
                            const page = this.pagesSelected.find(page => page.id == pageId) || this.allPages.find(page => page.id == pageId)
                            const post = this.dataEditPost.posts.find(post => post.page == pageId)
                            
                            if (post) {
                                formData.postId = post.postId
                                formData.id = post._id
                                
                                requestGroup.push({
                                    start : async (onSuccess, onProgress, onError) => {
                                        try {
                                            const response = await this.putPost(formData);
                                            if (response.data.success) {
                                                onSuccess(`Post ${formData["data[scheduled_date]"] ? 'planifié' : 'publié'} avec succés`);
                                                return {response, formData: { ...formData, pageId }}
                                            }else{
                                                throw new Error(`Echec lors de la ${formData["data[scheduled_date]"] ? 'planification' : 'publication'} du post`);
                                            }
                                        } catch (error) {
                                            onError(error.message);
                                            return {response:null, formData: { ...formData, pageId }}
                                        }
                                    },
                                    params : {
                                        picture : formData["data[enclosure]"] || page.avatar,
                                        title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                                        loadingText: !formData["data[scheduled_date]"] ? "En cours de publication..." : "En cours de planification..."
                                    }
                                });
                            }else{
                                requestGroup.push({
                                    start : async (onSuccess, onProgress, onError) => {
                                        try {
                                            const response = await this.new(formData);
                                            if (response.data.success) {
                                                onSuccess(`Post ${formData["data[scheduled_date]"] ? 'planifié' : 'publié'} avec succés`);
                                                return {response, formData: { ...formData, pageId }}
                                            }else{
                                                throw new Error(`Echec lors de la ${formData["data[scheduled_date]"] ? 'planification' : 'publication'} du post`);
                                            }
                                        } catch (error) {
                                            onError(error.message);
                                            return {response:null, formData: { ...formData, pageId }}
                                        }
                                    },
                                    params : {
                                        picture : formData["data[enclosure]"] || page.avatar,
                                        title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                                        loadingText: !formData["data[scheduled_date]"] ? "En cours de publication..." : "En cours de planification..."
                                    }
                                });
                            }
                        }  
                    }
                    break;
                }
                case 'draft': {
                    for (const [pageId, formData] of Object.entries(this.dataFormRequest)) {
                        if (!formData.hasOwnProperty('error')) {
                            const page = this.pagesSelected.find(page => page.id == pageId) || this.allPages.find(page => page.id == pageId)
                            requestGroup.push({
                                start : async (onSuccess, onProgress, onError) => {
                                    try {
                                        const response = await this.new({
                                            ...formData,
                                            "data[removeDraft]": this.draft.id
                                        });
                                        if (response.data.success) {
                                            onSuccess(`Post ${formData["data[scheduled_date]"] ? 'planifié' : 'publié'} avec succés`);
                                            return {response, formData: { ...formData, pageId }}
                                        }else{
                                            throw new Error(`Echec lors de la ${formData["data[scheduled_date]"] ? 'planification' : 'publication'} du post`);
                                        }
                                    } catch (error) {
                                        onError(error.message);
                                        return {response:null, formData: { ...formData, pageId }}
                                    }
                                },
                                params : {
                                    picture : formData["data[enclosure]"] || page.avatar,
                                    title : `<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: ${formData["data[title]"] || "post medias"}`,
                                    loadingText: !formData["data[scheduled_date]"] ? "En cours de publication..." : "En cours de planification..."
                                }
                            });
                        }
                    
                    }
                    break;
                }
            }
            

            EventBus.$emit('requestManagerAddGroup',requestGroup, async(responses)=> {
                try {
                    const posts = responses.filter(({response}) => response.data.success && response.data.news && response.data.post && response.data.post.success).map(({response, formData}) => ({
                        _id: response.data.news._id,
                        bot: formData.bot,
                        page: formData.pageId,
                        postId: response.data.post.post,
                        status: 1,
                        story: null,
                    }))

                    if (posts.length > 1) {
                        const res = await this.updatePostsMultiPages(posts)
                    }
                   
                    if(this.mode == 'draft' && responses.length == posts.length) {
                        try {
                            this.deleteDraft(this.draft.id)
                        } catch (error) {
                            console.error("Echec de la supression du draft")
                        }
                    }
                  
                } catch (error) {
                    console.error(error.message)
                }
            })   

            this.$router.push({
                name: 'planner',
            })
        },  

        async changePreviewDisplay(state, pageSelected = null) {
            console.log("changePreviewDisplay", {state, pageSelected})
            if (state) {
                if (pageSelected) {
                    this.$set(this.previewMode, 'pageSelected', pageSelected)
                }else if (!this.previewMode.pageSelected) {
                    for (let i = 0; i < listNetworkSort.length; i++) {
                        const page = this.pagesSelected.find(p => p.network == listNetworkSort[i])
                        if (page) {
                            this.$set(this.previewMode, 'pageSelected', page)
                            break
                        }
                    }
                }
                console.log('this.previewMode.pageSelected', this.previewMode.pageSelected)
                if (!this.previewMode.active) {
                    this.generateDataFormRequest()
                    this.$set(this.previewMode, 'active', true)
                }
            }else{
                this.$set(this.previewMode, 'active', false)
                // this.$refs.postCreator.classList.remove('annimate-switch-preview-mode');

                // if (this.timeOutAnnimateForm) clearTimeout(this.timeOutAnnimateForm)
                // this.$nextTick(() => {
                //     this.timeOutAnnimateForm = setTimeout(() => {
                //         if (this.formShow == "preview-left") {
                //             this.formShow = "formUnique"
                //         }else{
                //             this.formShow = "formMultiple"
                //         }
                //     }, 1000);
                // })
            }
        },

        async deletePostFromClickSelectPage(params) {
            //Suprime le post liée a une page
            const post = this.dataEditPost.posts.find(post => post.page == params.pageId);
            const page = this.pagesSelected.find((page) => page.id == params.pageId)

            this.$set(this.dataEditPost, 'posts', this.dataEditPost.posts.filter(post => post.page !== params.pageId))
            this.$store.commit('selectPage/updateSelectPagePageSelected', this.pagesSelected.filter(page => page.id !== params.pageId))
            
            EventBus.$emit('requestManagerAdd',async (onSuccess, onProgress, onError)=> {

                try {
                    const response = await this.deletePost({
                        _id: post._id,
                        _bots:[{
                            id: post.bot,
                            page: {
                                network: page.network,
                            }
                        }],
                        page: [{
                            post_number: post.postId,
                            status: post.status
                        }]
                    });

                    if (response.data.success) {
                        onSuccess(`Post supprimé avec succés`);
                    }else{
                        throw new Error(`Échec lors de la suppression du post`);
                    }
                } catch (error) {
                    this.$set(this.dataEditPost, 'posts', [...this.dataEditPost.posts, post])
                    this.$store.commit('selectPage/updateSelectPagePageSelected', [...this.pagesSelected, post])
                    onError(error.message);
                }  
            }, {
                picture: page.avatar,
                title:`<span class="pink">${page.name.charAt(0).toUpperCase() + page.name.slice(1)}</span>: post planifié`,
                loadingText: "En cours de suppression...",
            })
        },
    },

    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },

        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'];
        }, 
    },

    watch: {
        mode: {
            immediate: true,
            handler(newValue, oldValue) {
   
                switch (newValue) {
                    case 'edit':
                    {
                        const dataEditPost = this.$store.getters['postCreator/getDataEditPost'];
                        if (
                            dataEditPost.draft && 
                            dataEditPost.draft.saveAllFormData && 
                            dataEditPost.draft.saveAllFormData.main.storification && 
                            Object.keys(dataEditPost.draft.saveAllFormData.main.storification).length &&
                            (
                                !dataEditPost.draft.saveAllFormData.main.storification.stickers ||
                                !Object.values(dataEditPost.draft.saveAllFormData.main.storification.stickers).some(sticker => sticker.type == 'post')
                            )
                        ) {
                            this.changeTab('story')
                        }
                    }
                    case 'draft':
                    {
                        const draft = this.$store.getters['postCreator/getDataDraft'];
                        if (
                            draft.id && 
                            draft.data.saveAllFormData && 
                            draft.data.saveAllFormData.main.storification && 
                            Object.keys(draft.data.saveAllFormData.main.storification).length &&
                            (
                                !dataEditPost.draft.saveAllFormData.main.storification.stickers ||
                                !Object.values(dataEditPost.draft.saveAllFormData.main.storification.stickers).some(sticker => sticker.type == 'post')
                            )
                        ) {
                            this.changeTab('story')
                        }
                    }
                }
            }
        },
        pagesSelected(newValue, oldValue) {
            if (this.mode == 'edit') {
                
                for (let i = 0; i < this.dataEditPost.posts.length; i++) {
                    const post = this.dataEditPost.posts[i];
                    if (!newValue.some(page => page.id == post.page)) {
                        this.$store.commit('selectPage/updateSelectPagePageSelected',oldValue)
                        EventBus.$emit(
                            "showModal", "Attention !", 
                            `Vous êtes sur le point de supprimer le post planifié lié à cette page`, 
                            "Fermer", 
                            "Confirmer", 
                            null, 
                            "postcreator/deletePostFromClickSelectPage",
                            {
                                pageId : post.page
                            }
                        );
                    }
                  
                }
               
            }
            this.setPagesInstagramActivedShareStory()
        },
    },

    beforeDestroy () {
        EventBus.$off('postcreator/uploadFile', this.uploadFile);
        EventBus.$off('postcreator/deletePostFromClickSelectPage', this.deletePostFromClickSelectPage);
    }

}
</script>
